import { cn } from './cn';

// Page title block. Every view had its own ad-hoc title row with a different
// size, weight and font; this is the one place that decides what a page title
// looks like.
//
// The title renders as the page's <h1> so each view has exactly one, which is
// what a screen reader's heading navigation expects.
export default function PageHeader({ title, sub, meta, actions, className = '' }) {
  return (
    <div className={cn('mb-4 flex flex-wrap items-start justify-between gap-x-4 gap-y-2 sm:mb-5 sm:items-end', className)}>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline gap-x-2.5 gap-y-1">
          <h1 className="type-h1 font-heading font-bold tracking-[-0.01em] text-ink">{title}</h1>
          {meta}
        </div>
        {sub && <p className="mt-1 text-[15px] text-ink-3">{sub}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
